import { render } from "./InputSuggestion.vue?vue&type=template&id=1b82dba9"
import script from "./InputSuggestion.vue?vue&type=script&lang=js"
export * from "./InputSuggestion.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__